import React, { useState } from 'react'
import { Drawer, Tabs, DatePicker, Menu, Dropdown, Badge } from 'antd'
import Select from '@atlaskit/select'
import ReactSelect from 'react-select'
import { Route, Switch, Link, useHistory, useParams } from 'react-router-dom'

import { useSelector } from 'react-redux'
import { AiOutlineDown } from 'react-icons/ai'

import { normalize, patientName, stringifyDate, useListData, usePet, useToggle } from '../../modules'

import Receive from '../reusable/receive'
import WriteInstructions from '../modals/writeInstructions'
import EditOrderItem from '../modals/editOrderItem'
import Elevated from '../modals/elevated'
import EntrySummary from './entrySummary'
import Confirm from '../reusable/confirm'
import CancelItem from '../modals/cancelItem'
import PreauthCheck from '../modals/preauthCheck'

const { TabPane } = Tabs
const { RangePicker } = DatePicker

const SendPatientFor = ({ patient, department="OutPatient", attachedTo, source, groups = [], group, tab: tb = "1" }) => {
    let { categories } = groups.find(grp => grp.name === group) ?? { categories: [] }

    const [ranges, setRanges] = useState()
    const [cat, setCat] = useState({ label: categories[0], value: categories[0] })
    const [selected, setSelected] = useState([])
    const [itm, setItm] = useState()
    const [index, setIndex] = useState()
    const [string, setString] = useState()
    const [sString, setSString] = useState()
    const [tab, setTab] = useState(tb)
    const [onSuccess, setOnSuccess] = useState(() => null)
    const [token, setToken] = useState()
    const [reason, setReason] = useState()
    const [preauthIndex, setPreauthIndex] = useState(null)

    const { id } = useParams()
    const history = useHistory()

    const { user } = useSelector(state => state.application)

    const [visible, toggleVisible] = useToggle(true)
    const [elevated, toggleElevated] = useToggle()
    const [includeOthers, toggleOthers] = useToggle()
    const [edit, toggleEdit] = useToggle()
    const [cancel, toggleCancel] = useToggle()
    const [instructions, toggleInstructions] = useToggle()
    const [preauthVisible, , setPreauthVisible] = useToggle()
    const [select, 
        // toggleSelect
    ] = useToggle()

    const close = () => {
        toggleVisible()
        setTimeout(() => history.goBack(), 300)
    }

    const elevate = fn => {
        setOnSuccess({ fn, setToken })
        setTimeout(toggleElevated, 200)
    }

    const selectItem = i => {
        setIndex(i)
        setTimeout(toggleInstructions, 100)
    }

    const saveInstructions = ins => {
        let temp = [...selected]
        temp[index].instructions = ins
        setSelected(temp)
    }

    const [
        { loading: iLoading, fetch: fetchItems },
        { list: items },
        { page = 1, limit = 10 }
    ] = useListData('saleItems', { string, category: cat.label }, { notify: true }, 'items')

    const [
        { loading: itLoading, error: itError, fetch: fetchBillItems },
        { list: billItems, count = 0 },
        { page: itPage = 1, limit: itLimit = 10, navigate, Paginate }
    ] = useListData('billedItems', ranges ? { 
        patient: patient?._id,
        string: sString, 
        group,
        attachedTo: includeOthers ? undefined : attachedTo?._id,
        from: ranges[0]?._d ?? null, 
        to: ranges[1]?._d ?? null
    } : { string: sString, attachedTo: includeOthers ? undefined : attachedTo?._id, group, patient: patient?._id, }, { notify: true }, 'items')

    const refresh = () => {
        navigate(1)
        fetchBillItems()
    }

    const onComplete = (_, notif, ops) => {
        notif(`Request${selected?.length > 1 ? 's' : '' } for the specified items ${selected?.length > 1 ? 'have' : 'has' } been sent`, ops('success'))
        clear()
        refresh()
        setTab("1")
    }

    const [{ loading: bLoading }, billPatient] = usePet('billPatient', {
        patient: patient?._id,
        attachedTo: attachedTo?._id,
        department,
        items: selected.map(({ _id, quantity, price, instructions, preauth }) => ({
            item: _id,
            quantity,
            instructions,
            price,
            preauth: preauth?._id ?? preauth,
        })),
        station: localStorage.getItem('station') ?? 'Cashier'
    }, { notify: true, callback: onComplete, manual: true, load: { msg: 'Adding items to bill...' } })

    const [{ loading: cLoading }, toggleCancelBilledItem] = usePet('toggleCancelBilledItem', {
        id: itm?._id,
        reason
    }, { notify: true, callback: ({ data }, notif, ops) => {
        notif(data?.cancelled ? 'Item has been cancelled' : 'Cancel action has been reversed', ops('success'))
        fetchBillItems()
    }, manual: true, load: { msg: itm?.cancelled ? 'Reversing cancel action' : 'Cancelling item' }, token })

    const cancelItem = it => {
        setItm(it)

        if (it?.cancelled)
            toggleCancelBilledItem()
        else
            toggleCancel()
    }

    const performCancel = rsn => {
        setReason(rsn)
        toggleCancelBilledItem()
    }

    const searchSent = str => {
        if (str?.trim()?.length >= 1 || !str) {
            setSString(str)
            refresh()
        }  
    }

    const search = str => {
        if (str?.trim()?.length >= 1 || !str) {
            setString(str)
            fetchItems()
        }  
    }

    const onCategoryChange = ct => {
        setCat(ct)
        fetchItems()
    }

    const modifyQty = (i, val) => {
        let temp = [...selected]
        temp[i].quantity += val

        if (temp[i].quantity <= 0)
            temp = temp.filter((_, k) => k !== i)

        setSelected(temp)
    }

    const selectRange = range => {
        setRanges(range)
        refresh()
    }

    const clear = () => setSelected([])

    const selectOthers = () => {
        toggleOthers()
        refresh()
    }

    const sendPatient = () => {
        const nextIndex = selected.findIndex(item => item?.preauthRequired && item?.preauthCategory && !item?.preauth)
        if (nextIndex < 0) return billPatient()

        setPreauthIndex(nextIndex)
        setPreauthVisible(true)
    }

    const attachPreauth = preauth => {
        let temp = [...selected]
        temp[preauthIndex].preauth = preauth
        setSelected(temp)
        setPreauthVisible(false)
        setPreauthIndex(null)

        setTimeout(() => {
            const nextIndex = temp.findIndex(item => item?.preauthRequired && item?.preauthCategory && !item?.preauth)
            if (nextIndex < 0) billPatient()
            else {
                setPreauthIndex(nextIndex)
                setPreauthVisible(true)
            }
        }, 100)
    }

    return (
        <Drawer
            closable
            maskClosable
            visible={visible}
            onClose={close}
            footer={
                <div className="w-full text-right">
                    <button onClick={ sendPatient } className="text-white hisani-btn-orange mr-3 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Send Patient</button>
                    <button onClick={ clear } className="text-white bg-gray-500 hover:bg-gray-600 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Clear Items</button>
                </div>
            }
            width={800}>
            <p className="font-extrabold text-3xl mb-0">{ group }</p>
            {
                index >= 0 &&
                <WriteInstructions
                    selected={ index }
                    onClose={ setIndex }
                    onSave={ saveInstructions }
                    pre={ selected[index]?.instructions }
                    visible={ instructions }
                    toggle={ toggleInstructions } />
            }
            {
                cancel &&
                <CancelItem
                    item={ itm }
                    onPerform={ refresh }
                    loading={ cLoading }
                    action={ performCancel }
                    visible={ cancel }
                    toggle={ toggleCancel } />
            }
            {
                edit &&
                <EditOrderItem
                    item={ itm }
                    onPerform={ fetchBillItems }
                    toggle={ toggleEdit }
                    visible={ edit } />
            }
            {
                elevated &&
                <Elevated
                    app="regular"
                    onSuccess={onSuccess}
                    toggle={toggleElevated}
                    visible={elevated} />
            }
            {
                preauthVisible &&
                <PreauthCheck
                    visible={ preauthVisible }
                    toggle={ () => {
                        setPreauthVisible(false)
                        setPreauthIndex(null)
                    } }
                    patient={ patient }
                    saleItem={ preauthIndex >= 0 ? selected[preauthIndex] : null }
                    onCreated={ () => {
                        setPreauthVisible(false)
                        setPreauthIndex(null)
                    } }
                    onProceed={ attachPreauth } />
            }
            <Tabs onChange={ setTab } activeKey={ tab } className="min-h-full">
                <TabPane key="0" tab="Send New">
                    <div className="w-full md:w-1/2 mb-6 md:mb-0">
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                            Send { patientName(patient?.name) } to
                        </label>
                        <Select
                            inputId="single-select-example"
                            className="single-select"
                            classNamePrefix="react-select"
                            onChange={ onCategoryChange }
                            value={ cat }
                            options={ categories.map(cat => ({ label: cat, value: cat })) }
                            placeholder="Choose Category" />
                    </div>
                    <div className="w-full my-6 md:mb-0">
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                            Select Items
                        </label>
                        <ReactSelect
                            isMulti
                            onInputChange={search}
                            onChange={ setSelected }
                            value={ selected }
                            isLoading={ iLoading }
                            styles={{
                                option: (styles, { data }) => { 
                                    let { current } = data
                                    return {
                                        ...styles, 
                                        backgroundColor: current <= 0 ? undefined : styles.backgroundColor,
                                        color: current <= 0 ? 'gray' : styles.color,
                                        cursor: current <= 0 ? 'not-allowed' : 'default'
                                    }
                                }
                            }}
                            options={ items?.map(itm => ({ label: `${itm.name}${itm.current <= 0 ? ` - Ksh. ${itm.price} (Out of Stock)` : '' }`, value: itm._id, ...itm, quantity: 1, isDisabled: itm?.current <= 0 })) }
                            placeholder={ `What items is ${patientName(patient?.name) } being sent for?` } />
                    </div>
                    <div className="p-3 mt-4">
                        {
                            selected.length > 0 ?
                                <div className="overflow-x-auto">
                                    <table className="table-auto w-full">
                                        {/* Table header */}
                                        <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                            <tr>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">{select ? 'Selected' : 'No'}</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Item</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">Quantity</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center"></div>
                                                </th>
                                            </tr>
                                        </thead>
                                        {/* Table body */}
                                        <tbody className="text-sm font-medium divide-y divide-gray-100">
                                            {
                                                selected.map((item, key) =>
                                                    <tr>
                                                        <td className="p-2">
                                                            <div className="text-center">{((page - 1) * limit) + (key + 1)}.</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="">{ item.name }</div>
                                                            <p className="text-gray-500 mb-0 text-xs italic">Unit Price: Ksh. { item.price }</p>
                                                            <p className="text-gray-500 mt-0 text-xs italic">Total: Ksh. { item.price * item.quantity }</p>
                                                        </td>
                                                        <td className="p-2 flex items-center justify-center">
                                                            <button onClick={() => modifyQty(key, -1)} type="button" className="px-4 py-3 rounded-md outline-none focus:ring-4 shadow-lg">-</button>
                                                            <span className="text-center px-3">{ item.quantity }</span>
                                                            <button onClick={() => modifyQty(key, 1)} type="button" className="px-4 py-3 rounded-md outline-none focus:ring-4 shadow-lg">+</button>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="flex items-center justify-center">
                                                                <button  onClick={ () => selectItem(key) } className="btn ml-2 hisani-btn-green-light text-white">
                                                                    <span className="hidden xs:block">Instructions</span>
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                    <div className="flex flex-col items-end mb-3 p-3">
                                        <p className="font-semibold text-lg underline mb-2">Total Selected</p>
                                        <p>Total: Ksh. { normalize(selected.reduce((total, itm) => total + (itm.price * itm.quantity), 0)) }</p>
                                    </div>
                                </div>
                                :
                                <div className="w-full h-16 mt-4 flex items-center justify-center">
                                    <p className="font-semibold text-base">You can add items by selecting from the list above</p>
                                </div>
                        }
                    </div>
                </TabPane>
                <TabPane key="1" tab={ <Badge count={ count }>Previously Sent</Badge> }>
                    <div className="sm:flex sm:justify-between sm:items-center mb-2">
                        <span>
                            <input
                                onChange={e => searchSent(e.target.value)}
                                className="appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                                id="grid-ssearch"
                                type="text"
                                placeholder="Search for item" />
                            <span>
                                <input
                                    onChange={ selectOthers }
                                    checked={ includeOthers }
                                    type="checkbox"
                                    className="form-checkbox cursor-pointer h-5 w-5" />
                                <span onClick={ selectOthers } className="text-gray-500 cursor-pointer text-xs italic ml-2">Show { group?.toLowerCase() ?? 'history' } from outside this period</span>
                            </span>
                        </span>
                        {
                            includeOthers &&
                            <RangePicker onChange={selectRange} />
                        }
                    </div>
                    <div className="">
                        <Receive
                            progress
                            loading={itLoading}
                            error={itError}>
                            {
                                billItems.length > 0 ?
                                    <div className="overflow-x-auto">
                                        <table className="table-auto w-full">
                                            {/* Table header */}
                                            <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                                <tr>
                                                    <th className="p-2">
                                                        <div className="font-semibold text-center">No</div>
                                                    </th>
                                                    <th className="p-2">
                                                        <div className="font-semibold text-left">Item</div>
                                                    </th>
                                                    <th className="p-2">
                                                        <div className="font-semibold text-left">Sent By</div>
                                                    </th>
                                                    <th className="p-2">
                                                        <div className="font-semibold text-center"></div>
                                                    </th>
                                                </tr>
                                            </thead>
                                            {/* Table body */}
                                            <tbody className="text-sm font-medium divide-y divide-gray-100">
                                                {
                                                    billItems.map((item, key) =>
                                                        <tr>
                                                            <td className="p-2">
                                                                <div className="text-center">{((itPage - 1) * itLimit) + (key + 1)}.</div>
                                                            </td>
                                                            <td className="p-2">
                                                                <div className="">{ item.name } { item.quantity > 1 && ` (x ${item.quantity})` }</div>
                                                                <p className="text-gray-500 my-0 text-xs italic">Sent On { stringifyDate(item.date) }</p>
                                                                <p className={ `text-${ item.cancelled ? 'gray' : item.seen ? 'green' : 'yellow'}-500 mt-0 text-xs italic mb-0` }>{ item.cancelled ? 'Cancelled' : item.seen ? 'Seen' : 'Pending' }</p>
                                                            </td>
                                                            <td className="p-2">
                                                                <div className="">{ item.sentBy?.name }</div>
                                                            </td>
                                                            <td className="p-2">
                                                                <Dropdown
                                                                    overlay={
                                                                        <Menu>
                                                                            {
                                                                                !item.cancelled &&
                                                                                <Link to={ `${source}/investigations/${item._id}` }><Menu.Item>View</Menu.Item></Link>
                                                                            }
                                                                            {
                                                                                !item.seen && (item.sentBy._id === user?._id || user?.issuperuser) &&
                                                                                <>
                                                                                    {
                                                                                        !item.cancelled &&
                                                                                        <Menu.Item onClick={ () => {
                                                                                            setItm(item)
                                                                                            toggleEdit()
                                                                                        } }>Edit</Menu.Item>  
                                                                                    }
                                                                                    <Menu.Item onClick={ () => {
                                                                                        setItm(item)
                                                                                        elevate(() => Confirm({
                                                                                            title: item.cancelled ? 'Undo Cancel?' : 'Cancel item',
                                                                                            message: item.cancelled ? 'This will undo the cancel action performed on this item.' : 'Please confirm before cancelling the selected item',
                                                                                            okText: item.cancelled ? 'Undo Cancel?' : 'Cancel item',
                                                                                            onOk: () => cancelItem(item)
                                                                                        }))
                                                                                    } }>{ item.cancelled ? 'Undo Cancel' : 'Cancel item' }</Menu.Item>
                                                                                    {
                                                                                        user?.issuperuser &&
                                                                                        <Menu.Item onClick={ () => null }>Delete</Menu.Item>  
                                                                                    }
                                                                                </>
                                                                            }
                                                                        </Menu>
                                                                    }>
                                                                    <a className="ant-dropdown-link flex items-center h-10" onClick={e => e.preventDefault()}><span className="mr-2">Actions</span> <AiOutlineDown /></a>
                                                                </Dropdown>
                                                            </td>
                                                        </tr>
                                                    )
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                    :
                                    <div className="w-full h-16 mt-4 flex items-center justify-center">
                                        <p className="font-semibold text-base">{patientName(patient?.name)} wasn't sent for any { group?.toLowerCase() ?? 'items' }</p>
                                    </div>
                            }
                        </Receive>
                        { Paginate }
                    </div>
                </TabPane>
            </Tabs>
            <Switch>
                <Route path={ `${source}/:category/:ref` }>
                    <EntrySummary path={ `${source}/${group.toLowerCase()}` }/>
                </Route>
            </Switch>
        </Drawer>
    )
}

export default SendPatientFor
